import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      textDecoration: 'none',
      color: palette.text.primary,
      padding: '0px 15px',
      gap: '10px',
      maxWidth: '179px',
      height: '44px',
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.buttonShadow,
      fontWeight: 600,
      fontSize: '13px'
    },
    burgermenuroot: {
      maxWidth: 'none'
    },
    active: {
      background: palette.gradient.main,
      color: palette.text.white,
      pointerEvents: 'none'
    },
    bottomMenuLink: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '44px',
      height: '44px',
      borderRadius: palette.borderRadius.default
    },
    activeBottomMenuLink: {
      backgroundColor: palette.background.underBox
    },
    burgerMenuText: {
      fontSize: '1.25rem',
      fontWeight: 700,
      color: palette.text.secondary,
      width: 'max-content',
      overflowX: 'visible'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
